import { type ComponentProps } from 'react';

import classNames from 'classnames';

import { IconPlus } from '@spotify-internal/encore-web';

import styles from './MenuTriggerPlusIcon.module.css';

type MenuTriggerPlusIconProps = ComponentProps<typeof IconPlus>;

export const MenuTriggerPlusIcon = ({
  className,
  ...props
}: MenuTriggerPlusIconProps) => (
  <IconPlus className={classNames(styles.icon, className)} {...props} />
);
